/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Data_On_PremiseInputs */



/**
* | output |
* | --- |
* | "Where is my data stored?" |
*
* @param {Uno_Welcome_Suggestion_Data_On_PremiseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_data_on_premise = /** @type {((inputs?: Uno_Welcome_Suggestion_Data_On_PremiseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Data_On_PremiseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wo werden meine Daten gespeichert?")
	return /** @type {LocalizedString} */ ("Where is my data stored?")
});